<template>
  <div>
    <v-list>
      <v-list-item-group
        v-model="selectedMenu"
        color="primary"
      >
        <draggable
          v-model="filteredMenus"
        >
          <v-list-item
            v-for="menu in filteredMenus"
            :key="menu.id"
          >
            <v-list-item-content>
              <v-list-item-title>{{ menu.name }}</v-list-item-title>

              <v-list-item-subtitle
                v-if="pages.length && menu.page_id"
              >{{ pageName(menu.page_id) | striptags }}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    text
                    icon
                    small
                    color="primary"
                    v-on="on"
                    @click.stop="editMenu(menu)"
                  >
                    <v-icon small>edit</v-icon>
                  </v-btn>
                </template>

                <span>Edit menu</span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
        </draggable>
      </v-list-item-group>
    </v-list>

    <div class="d-flex justify-center mt-3">
      <v-btn
        color="primary"
        depressed
        rounded
        small
        @click="addMenuItem()"
      >Add menu item</v-btn>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'Menu',
  components: {
    draggable
  },
  props: {
    level: Number,
    parentId: {
      type: Number,
      required: false,
      default: null
    },
    pages: Array
  },
  computed: {
    selectedMenu: {
      get() {
        return this.filteredMenus
          .findIndex(m => m.id === this.$store.state.Menus.selectedMenu[this.level])
      },
      set(value) {
        this.$store.commit('Menus/setSelectedMenu', {
          level: this.level,
          menuId: this.filteredMenus[value] ? this.filteredMenus[value].id : null
        })
      }
    },
    filteredMenus: {
      get() {
        const menu = [...this.$store.state.Menus.menus]
        menu.sort((a, b) => { return a.order < b.order ? -1 : 1 })
        return menu.filter(m => m.parent_id === this.parentId)
      },
      set(value) {
        value.forEach((menu, index) => { menu.order = index + 1 })
        this.$store.dispatch('Menus/updateMenuOrder', value)
      }
    }
  },
  methods: {
    pageName(pageId) {
      return this.pages.find(p => p.id === pageId).title
    },
    addMenuItem() {
      this.$store.dispatch('Menus/createMenuItem', {
        name: 'New item',
        parent_id: this.parentId,
        order: this.filteredMenus.length
      })
    },
    editMenu(menu) {
      this.$store.commit('Menus/openMenuDialog', menu)
    }
  }
}
</script>
